import
  React, {
  useContext
} from 'react';

import {
  PropTypes
} from 'prop-types';

import {
  VContainer
} from '@vodacom/web-common';

import {
  DrupalProvider
} from 'providers';

import {
  TabView
} from 'components';

import {
  RssCarousel,
  Trends
} from '.';

import {
  CacheKeys,
  ErrorKeys,
  FeatureToggles
} from '../../../constants';

import {
  handleUtagLinkEvent,
  isEqual,
  isFeatureEnabled
} from 'helpers';

import {
  HandleRender
} from 'hocs';

import {
  AppContext
} from 'context';

export const NewsFeed = props => {

  const { config } = useContext(AppContext);

  const [ state, setState ] = React.useState({
    rssFeeds: [],
    loading: true,
    error: null,
    tabList: null,
    tabDataList: null
  });

  const getRssFeeds = async () => {

    const rssFeeds = await DrupalProvider.getCachedItem(CacheKeys.RssFeeds, null, DrupalProvider.getRssFeeds);

    if (!rssFeeds?.ok) {

      setState(prevState => ({
        ...prevState,
        loading: false,
        error: rssFeeds?.error
      }));

      return [];
    }

    setState(prevState => ({
      ...prevState,
      rssFeeds: rssFeeds?.result,
      loading: false
    }));

    return rssFeeds?.result;
  };

  const rssCarouselComponent = (feedCategory, feedsInformation) => {

    return (

      <VContainer margin={'20px 0'}>
        <RssCarousel
          feedCategory={feedCategory}
          feedsInformation={feedsInformation}
        />
      </VContainer>
    );
  };

  const createComponent = (title, feeds) => {

    return {
      component: rssCarouselComponent(
        title,
        feeds
      ),
      value: title.toUpperCase()
    };
  };

  const buildTabData = (rssFeeds) => {
    let data = [];
    let list = [];

    for (let i = 0; i < rssFeeds.length; i ++) {
      const rssFeed = rssFeeds[i];

      data.push(createComponent(rssFeed.title, rssFeeds?.find((element) => isEqual(element.title, rssFeed.title))?.feeds));
      list.push({
        value: rssFeed.title.toUpperCase(),
        label: rssFeed.title.toUpperCase()
      });
    }

    if (isFeatureEnabled(config, FeatureToggles.EnableTwitterFeed)) {
      const value = 'TRENDS';
      const trendIndex =
        rssFeeds.length > 1
          ? 2
          : rssFeeds.length / 2;

      data.splice(trendIndex, 0, {
        component: <Trends numberOfTrends={props.numberOfTrends} showTrendsButton={props.showTrendsButton} />,
        value
      });

      list.splice(trendIndex, 0, {
        value: value,
        label: value
      });

    }

    setState(prevState => ({
      ...prevState,
      tabDataList: data,
      tabList: list
    }));
  };

  React.useEffect(() => {

    const init = async () => {

      let rssFeeds =
        isFeatureEnabled(config, FeatureToggles.EnableFeeds)
          ? await getRssFeeds()
          : [];

      if (rssFeeds.length === 0) {
        setState(prevState => ({
          ...prevState,
          loading: false
        }));
      }

      buildTabData(rssFeeds);
    };

    init();

    // TODO: return cleanup function for async calls on unmount

  }, []);

  return (

    <HandleRender
      isLoading={state.loading}
      isError={state.error}
      error={{ type: ErrorKeys.General, title: 'News Feed' }}>
      {
        state.tabDataList?.length > 0 &&
        state.tabList?.length > 0 &&

        <TabView
          margin={`${props.margin}`}
          tabList={state?.tabList}
          tabData={state?.tabDataList}
          onTabClick={tab => {

            handleUtagLinkEvent({
              content_title: `cbu: connectu: rss feed: ${tab?.value}`,
              page_section: 'rss feed components',
              content_feed_events: 'content_load'
            });
          }}
        />
      }
    </HandleRender>
  );
};

NewsFeed.propTypes = {
  showTrendsButton: PropTypes.bool,
  numberOfTrends: PropTypes.number,
  margin: PropTypes.string
};

NewsFeed.defaultProps = {
  showTrendsButton: false,
  numberOfTrends: 10,
  margin: '16px 0 0 16px'
};
